<template #default>
    <div class="widget-container">
        <!-- <h2 class="content-block">New Order</h2> -->
        <div class="content-block dx-card responsive-paddings">
            <form action="action" @submit.prevent="onFormSubmit">
                <DxForm id="form1" :form-data="formData" label-mode="floating">
                    <DxGroupItem :col-count="2" :caption="$t('orderAdd.orderDetails')">
                        <DxSimpleItem data-field="PoDate" editor-type="dxDateBox" :editor-options="dateOptions">
                            <DxLabel :text="$t('orderAdd.poDate')" />
                            <DxRequiredRule />
                        </DxSimpleItem>
                        <DxSimpleItem data-field="PoNumber">
                            <DxLabel :text="$t('orderAdd.poNumber')" />
                        </DxSimpleItem>
                        <!-- <DxSimpleItem data-field="POAttachment">
                            <DxLabel text="PO Attachment" />
                        </DxSimpleItem> -->
                    </DxGroupItem>

                    <DxGroupItem :caption="$t('orderAdd.orderItems')" :col-count="1">
                        <DxSimpleItem name="OrderItemsGrid_">
                            <template #default>
                                <DxDataGrid id="OrderItemsGrid" :show-borders="true" :data-source="OrderItemsData"
                                    :row-alternation-enabled="true" :hover-state-enabled="true"
                                    @saved="onRowSaved($event)"
                                    :selection="{ mode: 'single' }" key-expr="Id">

                                    <DxColumn :caption="$t('orderAdd.product')" data-field="Product" :set-cell-value="setMinimumValue" :group-index="0">
                                        <DxFormItem :col-span="2" />
                                        <DxLookup :data-source="ProductOptions" value-expr="Id" display-expr="Name" />
                                        <DxRequiredRule />
                                    </DxColumn>

                                    <DxColumn :caption="$t('orderAdd.minimumOrderQuantity')" data-field="MinimumOrderQuantity"
                                        :allow-editing="false">
                                        <DxFormItem editor-type="dxNumberBox" />
                                        <DxRequiredRule />
                                    </DxColumn>

                                    <DxColumn :caption="$t('orderAdd.moqUnits')" data-field="MOQUnits" :set-cell-value="setMOQUnits">
                                        <DxFormItem editor-type="dxNumberBox" />
                                        <DxRequiredRule />
                                    </DxColumn>

                                    <DxColumn :caption="$t('orderAdd.totalQuantity')" data-field="TotalQuantity"
                                        :allow-editing="false">
                                        <DxFormItem editor-type="dxNumberBox" />
                                    </DxColumn>

                                    <DxColumn :caption="$t('orderAdd.rate')" data-field="Rate"
                                        :allow-editing="false" format="#,##0.##">
                                        <DxFormItem editor-type="dxNumberBox" />
                                    </DxColumn>

                                    <DxColumn :caption="$t('orderAdd.totalPrice')"
                                       data-field="TotalPrice"
                                       :allow-editing="false" format="#,##0.##">
                                        <DxFormItem editor-type="dxNumberBox" />
                                    </DxColumn>

                                    <DxEditing mode="form" :allow-deleting="true" :allow-updating="true"
                                        :allow-adding="true" />
                                    <DxColumnFixing :enabled="true" />
                                    <DxGroupPanel :visible="true" />
                                </DxDataGrid>
                            </template>
                        </DxSimpleItem>
                    </DxGroupItem>              

                    <DxGroupItem :col-count="2" :caption="$t('orderAdd.shipping')">
                        <DxSimpleItem :col-span="1" data-field="ShipToLocation" :label="{ text: $t('orderAdd.shipToLocation') }"
                            editor-type="dxSelectBox" :editor-options="{
                                dataSource: FacilityOptions,
                                displayExpr: 'Name',
                                valueExpr: 'Id',
                                searchEnabled: true,
                                onValueChanged: handleShipToLocation
                            }" :validation-rules="[{ type: 'required', message: $t('orderAdd.shipToLocationRequired') }]" />

                        <DxSimpleItem :col-span="1" data-field="ShippingMethod" :label="{ text: $t('orderAdd.shippingMethod') }"
                            editor-type="dxSelectBox" :editor-options="{
                                dataSource: ShippingMethodOptions,
                                displayExpr: 'Name',
                                valueExpr: 'Id',
                                searchEnabled: true,
                                onValueChanged: handleShippingMethod
                            }"
                            :validation-rules="[{ type: 'required', message: $t('orderAdd.shippingMethodRequired') }]" />
                    </DxGroupItem>

                    <DxGroupItem :col-count="3" :caption="$t('orderAdd.charges')">
                        <DxSimpleItem data-field="TotalCharges" :editor-options="{ readOnly: true, format: '#,##0.##' }">
                            <DxLabel :text="$t('orderAdd.totalCharges')" />
                        </DxSimpleItem>
                        <DxSimpleItem data-field="ShippingHandling" :editor-options="{ readOnly: true, format: '#,##0.##' }">
                            <DxLabel :text="$t('orderAdd.shippingHandling')" />
                        </DxSimpleItem>
                        <DxSimpleItem data-field="TotalBeforeTaxes" :editor-options="{ readOnly: true, format: '#,##0.##' }">
                            <DxLabel :text="$t('orderAdd.totalBeforeTaxes')" />
                        </DxSimpleItem>
                    </DxGroupItem>

                    <DxGroupItem :col-count="1" :caption="$t('orderAdd.notes')">
                        <DxSimpleItem data-field="Notes" :editor-options="{ height: 90 }" editor-type="dxTextArea">
                            <DxLabel :text="$t('orderAdd.notes')" />
                        </DxSimpleItem>
                    </DxGroupItem>

                    <DxGroupItem :col-count="1">
                        <DxButtonItem :button-options="buttonOptions" horizontal-alignment="right" />
                    </DxGroupItem>
                </DxForm>
            </form>
        </div>
    </div>
</template>

<script>
import DxForm, {
    DxGroupItem,
    DxSimpleItem,
    DxButtonItem,
    DxLabel,
    // DxItemPanel,
    // DxItem,    
    DxRequiredRule,
    DxCompareRule,
    DxRangeRule,
    DxStringLengthRule,
    DxPatternRule,
    DxEmailRule,
    DxAsyncRule,
} from 'devextreme-vue/form'

import DxCheckBox from 'devextreme-vue/check-box';
import DxTooltip from 'devextreme-vue/tooltip';

import DxItemPanel from "devextreme-vue/tab-panel"
import DxAutocomplete from 'devextreme-vue/autocomplete'
import {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxToolbar,
    DxItem,
    DxFormItem,
    DxLookup,
    DxMasterDetail,
    DxColumnFixing,
    DxGroupPanel,
} from 'devextreme-vue/data-grid'

import DxRadioGroup from 'devextreme-vue/radio-group'

import DxButton from 'devextreme-vue/button'

import notify from 'devextreme/ui/notify'
import dateUtil from '@/helpers/dateUtil'

import { mapState, mapActions } from 'vuex'

import {
    POST_PURCHASE_ORDER, GET_PURCHASE_ORDER_LIST, GET_REVENUE_SOURCE, GET_FACILITY
} from '@/store/_actiontypes'

export default {
    components: {
        DxGroupItem,
        DxSimpleItem,
        DxButtonItem,
        DxButton,
        DxRadioGroup,
        DxLabel,
        DxItemPanel,
        DxItem,
        DxDataGrid,
        DxColumn,
        DxEditing,
        DxFormItem,
        DxLookup,
        DxMasterDetail,
        DxToolbar,
        DxRequiredRule,
        DxCompareRule,
        DxPatternRule,
        DxRangeRule,
        DxEmailRule,
        DxStringLengthRule,

        DxCheckBox,
        DxTooltip,

        DxForm,
        DxAutocomplete,
        DxAsyncRule,
        DxColumnFixing,
        DxGroupPanel,

        notify,
    },

    data() {
        const incorporationData = {}
        const status = [
            {
                Id: 'Former',
                Name: this.$t('orderAdd.former')
            },
            {
                Id: 'Current',
                Name: this.$t('orderAdd.current')
            }
        ]

        return {
            CDP: {},
            ProductOptions: status,
            LastSelectedProduct: '',
            dataOperation: [this.$t('orderAdd.new'), this.$t('orderAdd.update')],
            statusEditorOptions: status,
            FacilityOptions: [],
            AccountingPeriodData: [],
            AuditedAccountsData: [],
            CurrentCompanySecretariesData: [],
            DirectorsReportsData: [],
            AuditorsReportsData: [],
            OrderItemsData: [],
            AppointmentOfAuditorsData: [],
            ReasonOfTermination: [],
            accPeriod: '', extract: '', extractDate: '',
            dateOptions: { displayFormat: "dd-MM-yyyy" },
            _dateOptions: { displayFormat: "dd-MM-yyyy", readOnly: true },
            selectedTabIndex: 0,
            isOrderVisible: true,

            formData: {
                TotalCharges: 0,
                ShippingHandling: 0,
                TotalBeforeTaxes: 0,
                PaymentDueDate: '',
                POAttachment: '',
                PoNumber: '',
                PoDate: '',
                Notes: '',
                ShipToLocation: '',
                ShippingMethod: ''
            },

            accountingPeriodOptions: {
                disabled: false,
                onValueChanged: e => {
                    //this.saveAccountingPeriodValue(e)
                },
            },
            extractOptions: {
                height: 70,
                onValueChanged: e => {
                    //this.saveExtractOfResolutionValue(e)
                },
            },
            incorporationData,
        }
    },

    computed: {
      ...mapState({
        payerId: state => state?.user?.user?.data?.payer?.id
      }),
      ShipToLocationOptions() {
        return [
          { Id: "Default", Name: this.$t('orderAdd.default') },
          { Id: "Dar es Salaam", Name: this.$t('orderAdd.darEsSalaam') }
        ]
      },
      ShippingMethodOptions() {
        return [
          { Id: 'standard', Name: this.$t('orderAdd.standardShipping') },
          { Id: 'expedited', Name: this.$t('orderAdd.expeditedShipping') }
        ]
      },
      buttonOptions() {
        return {
          text: this.$t('orderAdd.save'),
          type: 'normal',
          useSubmitBehavior: true
        }
      }
    },

    created() {
        this.loadRevenueSourceData()
        this.loadFacilityData()
    },

    props: {
        cdpSelectedItem: {
            type: Object,
            default: () => { },
        },
    },

    methods: {
        ...mapActions("payment", [
            POST_PURCHASE_ORDER, GET_PURCHASE_ORDER_LIST, GET_REVENUE_SOURCE
        ]),

    ...mapActions("application", [
            GET_FACILITY
        ]),

        onFormSubmit() {
            if (this.OrderItemsData.length) {
                let OrderDetails = this.OrderItemsData.map((item, index) => {
                    return {
                        periodicity: 1,
                        source_id: item.Product,
                        description: this.$t('orderAdd.order'),
                        ccy: "CDF",
                        qty: item.TotalQuantity,
                        rate: item.Rate,
                        amount: item.TotalPrice
                    }
                })
                let payload = {
                    OrderDetails,
                    _params: {
                        order_no: "",
                        shipping_address: this.formData.ShipToLocation,
                        shipping_date: this.formData.PoDate,
                        shipping_method: this.formData.PoDate,
                        shipping_method: this.formData.Notes,
                        payer_id: this.payerId,
                        account_descr: this.$t('orderAdd.order'),
                        dcl_type: 1,
                        ccy:"CDF",                        
                    }
                }
                this.POST_PURCHASE_ORDER(payload).then(res => {
                    this.$router.push('/orders')
                    this.$toast.success(this.$t('orders.orderProcessedSuccess'))
                })
                .catch(error => {
                    console.log(error)
                    this.$toast.error(error?.data?.errors?.message || this.$t('errors.unexpectedError'));
                })
            }
            else {
                this.$toast.error(this.$t('orders.orderItemRequired'))
            }
        },
        
        onRowSaved(e) {
            const total = this.OrderItemsData.reduce((sum, item) => sum + Number(item.TotalPrice), 0);
            this.formData.TotalCharges = Number(total);
            this.formData.TotalBeforeTaxes = Number(total);
        },

        loadFacilityData() {
            this.GET_FACILITY().then(res => {
                this.FacilityOptions = res.data.map((item, index) => {
                    return {
                        Id: item.facility_Name,
                        Name: item.facility_Name
                    }
                })
            })
            .catch(error => {
                console.log(error)
            })
        },


        handleShippingMethod(e) {

        },

        handleShipToLocation(e) {
            this.formData.Facility = e.value
            console.log(this.formData)
        },
        selectShippingMethod(method) {
            // this.formData.selectedShippingMethod = method;
        },

        loadRevenueSourceData() {
            this.GET_REVENUE_SOURCE().then(res => {
                this.ProductOptions = res.data?.body[0]?.sources.map((item, index) => {
                    return {
                        Id: item.id,
                        Name: item.source_name,
                        Rate: item.rate,
                        Currency: item.currency,
                        Min_qty: item.min_qty
                    }
                })
            })
            .catch(error => {
                console.log(error)
            })
        },

        setMinimumValue(rowData, value) {
            let dataSet = this.ProductOptions.filter(e => e.Id === value)
            rowData.Product = value
            this.LastSelectedProduct = value
            rowData.MinimumOrderQuantity = dataSet[0].Min_qty
        },


        setMOQUnits(rowData, value) {
            let dataSet = this.ProductOptions.filter(e => e.Id === this.LastSelectedProduct);
            //console.log(this.LastSelectedProduct);

            rowData.MOQUnits = value;
            rowData.MinimumOrderQuantity = dataSet[0].Min_qty;
            rowData.Rate =dataSet[0].Rate

            // Calculate TotalQuantity and approximate to 2 decimal places
            const totalQty = Number(dataSet[0].Min_qty) * Number(value);
            rowData.TotalQuantity = parseFloat(totalQty.toFixed(2)); // Use parseFloat to convert back to a number

            // Calculate TotalPrice and approximate to 2 decimal places
            const totalPrice = totalQty * Number(dataSet[0].Rate); // Use the already calculated totalQty
            rowData.TotalPrice = parseFloat(totalPrice.toFixed(2)); // Use parseFloat to convert back to a number
        },

        resetInputFiels() {
            this.AuditedAccountsData = []
            this.DirectorsReportsData = []
            this.AuditorsReportsData = []
            this.OrderItemsData = []
            this.AppointmentOfAuditorsData = []
        },
    }
}
</script>